module.exports = __webpack_public_path__ + "img/design_1.1746a5f7.png";